import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Button, FlexBox, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { useToggle } from 'react-use';
import { useCustomFields } from 'utils/customFields';
import { CustomFieldChip } from './components/customFieldChip/customFieldChip';
import styles from './conversationPreviewCustomFields.module.scss';
const initiallyVisibleItemCount = 10;
export const ConversationPreviewCustomFields = ({ csid, scrollable = false, className, showSectionIcon, }) => {
    const { customFields } = useCustomFields({
        entityId: 'conversation',
        entityInstanceId: csid,
    });
    const itemsWithValue = customFields.filter((customField) => customField.value !== undefined);
    const showToggleButton = initiallyVisibleItemCount < itemsWithValue.length;
    const [showAllItems, toggleShowAllItems] = useToggle(false);
    const renderedItems = itemsWithValue.slice(0, showAllItems ? itemsWithValue.length : initiallyVisibleItemCount);
    const unrenderedItemsLength = itemsWithValue.length - renderedItems.length;
    const rootClass = classnames(styles.root, {
        [styles.rootScrollable]: scrollable,
    }, className);
    if (!itemsWithValue.length) {
        return null;
    }
    return (_jsxs(FlexBox, Object.assign({ className: rootClass, flexDirection: "row", gap: "200", alignItems: "center" }, { children: [showSectionIcon && (_jsx(Tooltip, Object.assign({ content: "Conversation Attributes", dark: true }, { children: _jsx(Avatar, { className: styles.icon, icon: "input", color: {
                        contentColor: colors.neutral[700],
                        backgroundColor: colors.neutral[100],
                    } }) }))), _jsx(FlexBox, Object.assign({ alignItems: "center", gap: "200", flexWrap: scrollable ? 'nowrap' : 'wrap' }, { children: renderedItems.map((customField) => {
                    return (_jsx(CustomFieldChip, { className: styles.customFieldChip, customField: customField }, customField.attribute.id));
                }) })), showToggleButton && (_jsx(Button, Object.assign({ variant: "tertiary", onClick: toggleShowAllItems }, { children: showAllItems ? `Show less` : `+ ${unrenderedItemsLength} more` })))] })));
};
